// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"_2kJDbKSBXr4PbNxlXdMctM","secondRowWithControls":"b_UQUrsK-wZI7BIM2Qe-R","verticalAlignBlock":"_3cv14XbVBTxFb9ObDRNjz0"};